import { combineReducers } from 'redux'
import notif from './notification'

const notificationReducer = combineReducers({
  notif,
})

export default notificationReducer
